import { RESTAURANT_API_PATHS } from '../constants/apiPaths';
import axiosRestaurantInstance from '../restaurant/AxiosRestaurantInstance';
import { ensureMenuImageFile } from '../restaurant/menuImageUtils';

function authHeaders() {
  const token = localStorage.getItem('Token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function appendPayloadToFormData(formData, payload) {
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (key === 'imageFile' || value == null || value === '') return;
    if (typeof value === 'boolean') {
      formData.append(key, value ? '1' : '0');
      return;
    }
    if (key === 'agePricing' && Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
      return;
    }
    if (key === 'nutrition' && value && typeof value === 'object') {
      formData.append(key, JSON.stringify(value));
      return;
    }
    if (Array.isArray(value)) {
      if (value.length === 0 && key === 'ingredientIds') {
        formData.append(key, '[]');
        return;
      }
      value.forEach((entry) => {
        if (entry != null && entry !== '') formData.append(key, String(entry));
      });
      return;
    }
    if (typeof value === 'object') {
      formData.append(key, JSON.stringify(value));
      return;
    }
    formData.append(key, String(value));
  });
}

async function postOrPutJreatsMainMenuItem(method, url, payload) {
  const headers = authHeaders();
  const imageFile = payload?.imageFile;

  if (imageFile) {
    const processed = await ensureMenuImageFile(imageFile);
    const formData = new FormData();
    appendPayloadToFormData(formData, payload);
    formData.append('image', processed, processed.name ?? 'menu-image.webp');
    return axiosRestaurantInstance.request({
      method,
      url,
      data: formData,
      headers: { ...headers, 'Content-Type': false },
    });
  }

  const { imageFile: _ignored, ...body } = payload || {};
  return axiosRestaurantInstance.request({
    method,
    url,
    data: body,
    headers: { ...headers, 'Content-Type': 'application/json' },
  });
}

export async function fetchJreatsMainMenuStates() {
  const res = await axiosRestaurantInstance.get(RESTAURANT_API_PATHS.jreatsMainMenuStates, {
    headers: authHeaders(),
  });
  return Array.isArray(res.data?.states) ? res.data.states : [];
}

export async function fetchJreatsMainMenu(state, { includeInactive = true } = {}) {
  const res = await axiosRestaurantInstance.get(RESTAURANT_API_PATHS.jreatsMainMenu, {
    headers: authHeaders(),
    params: {
      state,
      includeInactive: includeInactive ? 'true' : undefined,
    },
  });
  return {
    state: res.data?.state || state,
    items: Array.isArray(res.data?.items) ? res.data.items : [],
    foodItemCount: Number(res.data?.foodItemCount) || 0,
  };
}

export async function createJreatsMainMenuItem(payload) {
  const res = await postOrPutJreatsMainMenuItem(
    'post',
    RESTAURANT_API_PATHS.jreatsMainMenu,
    payload,
  );
  return res.data;
}

export async function updateJreatsMainMenuItem(foodItemId, payload) {
  const res = await postOrPutJreatsMainMenuItem(
    'put',
    RESTAURANT_API_PATHS.jreatsMainMenuById(foodItemId),
    payload,
  );
  return res.data;
}

export async function deactivateJreatsMainMenuItem(foodItemId) {
  const res = await axiosRestaurantInstance.delete(
    RESTAURANT_API_PATHS.jreatsMainMenuById(foodItemId),
    { headers: authHeaders() },
  );
  return res.data;
}
